export function groupProjectRows(filtered,all){
 const full=new Map();for(const p of all){const id=p.project_group_id||p.id;if(!full.has(id))full.set(id,[]);full.get(id).push(p);}
 const matches=new Map();for(const p of filtered){const id=p.project_group_id||p.id;if(!matches.has(id))matches.set(id,[]);matches.get(id).push(p);}
 return [...matches].map(([id,rows])=>{
  const allReports=[...full.get(id)].sort((a,b)=>(a.report_index||0)-(b.report_index||0));
  const reports=[...rows].sort((a,b)=>(a.report_index||0)-(b.report_index||0));const p=allReports[0];
  const completeFees=reports.every(r=>r.financials?.[0]?.agreed_fee!=null&&Number.isFinite(Number(r.financials[0].agreed_fee)));
  return {id,code:p.project_group_code||p.project_code,name:p.project_name,reports,allReports,primary:p,multi:allReports.length>1,partial:reports.length<allReports.length,
   status:new Set(reports.map(r=>r._status??r.status)).size===1?(reports[0]._status??reports[0].status):'Mixed',
   fee:completeFees?reports.reduce((sum,r)=>sum+Number(r.financials[0].agreed_fee),0):null,
   pending:completeFees?reports.reduce((sum,r)=>sum+(r._pending??0),0):null};
 });
}
export const publicationStates={published:['✓','published'],pending_review:['!','review'],review:['!','review'],approved:['◷','progress'],publishing:['↗','progress'],queued:['◷','progress'],preparing:['•','progress'],revision_requested:['↻','progress'],waiting_sources:['?','waiting'],blocked:['Ⅱ','waiting'],uncertain:['!','error'],archived:['−','waiting'],skipped:['−','waiting']};

// Preserve historic code-year ordering; use creation date for undated new reports.
export function projectSortDate(project) {
 if (project.order_date) return project.order_date;
 const created = project.created_at?.slice(0, 10);
 const code = project.project_group_code || project.project_code || '';
 const match = code.match(/^(?:LP|RP)-(\d{2})\d+(?:-[A-Z]+)?$/i);
 // Imported historic rows may have recent ingestion timestamps.
 if (match && (!created || Number('20' + match[1]) < Number(created.slice(0, 4)))) return `20${match[1]}-01-01`;
 if (created && /^\d{4}-\d{2}-\d{2}$/.test(created)) return created;
 if (match) return `20${match[1]}-01-01`;
 return '';
}
